import { render, staticRenderFns } from "./rule-ip.vue?vue&type=template&id=0286a68c"
import script from "./rule-ip.vue?vue&type=script&lang=js"
export * from "./rule-ip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports